import React from 'react'
import { render } from 'react-dom'
import App from './App'
export { i18n } from '../lang'

render(<App />, document.getElementById('root'))
